/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Staging_BadgeInputs */

const cs_gallery_staging_badge = /** @type {(inputs: Gallery_Staging_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI staging — uveďte, pokud je to vyžadováno`)
};

const en_gallery_staging_badge = /** @type {(inputs: Gallery_Staging_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI staging — disclose if required`)
};

/**
* | output |
* | --- |
* | "AI staging — disclose if required" |
*
* @param {Gallery_Staging_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_staging_badge = /** @type {((inputs?: Gallery_Staging_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Staging_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_staging_badge(inputs)
	return cs_gallery_staging_badge(inputs)
});